export const namedColors = {
    purple: '#753BBD', // the primary color
    primary: '#753BBD',
    blue: '#4862DF',
    blueGreen: '#00A0B0',
    palePurple: '#ac89d7',
    lightPurple: '#9062ca',
    darkPurple: '#5d2f97',
    darkerPurple: '#462371',
    backgroundPurpleRGBA: 'rgba(235, 226, 245, 0.3)',
    white: '#ffffff',
    snow: '#f8f8f8',
    //lightGray: `rgba(128,128,128,0.2)`,
    lightGray: '#e6e6e6',
    // For usage with 1px box-shadow borders instead of a solid color, to make ot work better in dark mode
    boxShadowBorder: `rgba(128,128,128,0.2)`,
    lightGrayChart: '#dddddd',
    gray: '#aaaaaa',
    darkGray: '#888888',
    darkerGray: '#444444',
    label: '#888888',
    black: '#222222',
    red: '#ed481e',
    orange: '#ff9000',
    yellow: '#ffc503',
    yellowGlass: '#ffc50333',
    green: '#18cd27',
    darkGreen: '#009320',
    backGroundGray: '#f5f5f5',
    backGroundGrayRGBA: 'rgba(0, 0, 0, 0.08)',
    backgroundLightPurpleRGBA: 'rgba(93, 47, 151, 0.08)',
    text: '#2e3933',
    charcoal: '#2e3933',
    grayishBlue: '#d2d5e0',
};

export type NamedColors = keyof typeof namedColors;

export type BinoTheme = {
    primary: string;
    primaryColor: string;
    textColor: string;
    labelColor: string;
    color: { [color in NamedColors]: string };
};

export const binoTheme: BinoTheme = {
    primary: namedColors.purple,
    primaryColor: namedColors.purple,
    textColor: namedColors.text,
    labelColor: namedColors.darkGray,
    color: namedColors,
};
export default binoTheme;
